import { ActionType } from "../types";
import {
  LandingZoneRoles,
  LandingZoneRolesAction,
} from "../types/landing-zone-roles";

export const landingZoneRoles = (
  state: LandingZoneRoles = null,
  action: LandingZoneRolesAction
): LandingZoneRoles => {
  switch (action.type) {
    case ActionType.GET_LANDING_ZONE_ROLES_REQUEST:
      return null;
    case ActionType.GET_LANDING_ZONE_ROLES_SUCCESS:
      return action.landingZoneRoles;
    case ActionType.GET_LANDING_ZONE_ROLES_FAILURE:
      return null;
    default:
      return state;
  }
};
